<template>
	<div class="dropzone" :class="{ allow }">
		<div class="droppable" :data-position="dropzone.position" :class="{ allow }" v-droppable>
			<div v-show="allow" class="hint"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import interact from 'interactjs'

export default {
	name: 'dropzone',
	props: {
		dropzone: { default: null }
	},
	computed: {
		...mapGetters([ 'game', 'room' ]),
		// card() {
		// 	return this.game.hero.position === this.dropzone.position ? this.game.hero : this.game.board.find(c => c.position === this.dropzone.position)
		// },
		allow() {
			if (this.game.status === 'ready') {
				if (this.game.dragging && this.game.dragging.targets) {
					if (this.room === Math.floor(this.dropzone.position / 7)) {
						if (!this.dropzone.card) return this.game.dragging.targets.includes('empty')
						return this.game.dragging.targets.includes(this.dropzone.card.type)
					}
				}
			}
			return false
		}
	},
	directives: {
		droppable: {
			inserted($el, binding, vnode) {
				const self = vnode.context
				interact($el).dropzone({
					accept: '.card-wrap-content',
					overlap: 0.2,
					ondragenter(event) {
						if (self.allow) event.target.classList.add('drop-activated')
					},
					ondrop(event) {
						event.target.classList.remove('drop-activated')
					},
					ondragleave(event) {
						event.target.classList.remove('drop-activated')
					},
				})

			}
		}
	},
}
</script>

<style lang="stylus" scoped>

.dropzone
	width cell_width
	height cell_height
	transition (0.42s * animation_duration) linear (0.06s * animation_duration)
	z-index 100
	pointer-events none
	.droppable
		absolute 0
		&.drop-activated
			.hint
				opacity 0.75
		.hint
			position absolute
			left 8px
			right 8px
			bottom 8px
			top 8px
			border-radius 50%
			opacity 0.5
			background-color alpha(#fff, 75%)
			box-shadow 0 0 40px 20px #fff, inset 0 0 40px 20px #fff
				


@keyframes arrow-down
	0%
		transform translateY(-16px)
	100%
		transform translateY(0)

</style>
